/** `members.name` 의 컬럼 폭. 넘치면 서버가 거절한다. */
const MAX_NAME_LENGTH = 20;

/** 아이디 부분을 못 읽었을 때. 서버는 1자 이상을 요구하므로 빈 값을 보낼 수 없다. */
const FALLBACK_NAME = '회원';

/**
 * 가입할 때 서버에 보낼 이름.
 *
 * **이 화면은 닉네임을 받지 않는다.** 게이트에 필드를 하나 더 놓으면 그만큼 덜 넘어오는데,
 * 온보딩에는 「건너뛰기」가 없어 어차피 다음 화면에서 받게 된다(14. 1차 오픈 범위 §6.2).
 * 그런데 서버는 `members.name` 이 NOT NULL 이라 가입 시점에 값을 요구한다 —
 * 그래서 이메일 아이디 부분을 임시로 채운다.
 *
 * 지어낸 값이 아니라 **이미 화면이 쓰고 있는 값**이다. 마이페이지는 닉네임이 없을 때
 * 같은 방식으로 표시한다(`pages/my/shell.tsx`). 그래서 가입 직후 인증 메일의 인사말과
 * 나중에 화면에 뜨는 이름이 어긋나지 않는다.
 *
 * 온보딩 닉네임을 서버에 저장하는 절차가 생기면 이 값은 그때 덮인다.
 */
export function nameFromEmail(email: string): string {
  const localPart = email.trim().split('@')[0] ?? '';
  const name = localPart.slice(0, MAX_NAME_LENGTH);

  return name.length > 0 ? name : FALLBACK_NAME;
}
